/* eslint-disable @typescript-eslint/no-unused-vars */
import { AutocompleteWithLabel, Counter } from '@adotel/components'
import {
  Button,
  ButtonBase,
  Divider,
  Fade,
  Typography
} from '@material-ui/core'
import { SvgIcon } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { ReactComponent as MyIconSvg } from '../../../../assets/images/Group.svg'
import { CounterWithLabel } from '../../../../components/CounterWithLabel'
import { DateRangePicker } from '../../../../components/DatePicker/DateRangePicker'
import { formatShortDateWithWeekDay } from '../../../../helpers/date'
import { persianRegex } from '../../../../helpers/regex'
import { getCurrenciesAvailable } from '../../../../helpers/userData'
import { getTranslate, lang } from '../../../../localization'
import { LocalizedLink } from '../../../../routes/localizedRoutes'
import calculateRangeOfDays from '../../CalculateRangeOfDays'
import convertDate from '../../ConvertDate'
import SearchWidgetArrivalDate from '../../SearchWidgetArrivalDate'
import SearchWidgetDepartureDate from '../../SearchWidgetDepartureDate'
import SearchWidgetGuests from '../../SearchWidgetGuests'
import SearchWidgetSearchInput from '../../SearchWidgetSearchInput'
import { SearchWidgetProps } from '../SearchWidgetProps'
import useStyles from './SearchWidgetMobileInterface.styles'

const SearchWidgetMobileInterface: React.FC<SearchWidgetProps> = ({
  selectRangeModalIsOpen,
  setSelectRangeModalIsOpen,
  selectNumberOfGuestsModalIsOpen,
  setSelectNumberOfGuestsModalIsOpen,
  dateObject,
  setdateObject,
  guestsNumber,
  setguestsNumber,
  datePickerRef,
  effectFunction,
  guestInfoRef,
  type,
  searchAvailabilityInput,
  setSearchAvailabilityInput,
  options,
  readMode,
  setreadMode,
  loadingForAccommodation,
  isInResultPage
}) => {
  useEffect(
    () => effectFunction(),
    [
      datePickerRef,
      selectRangeModalIsOpen,
      selectNumberOfGuestsModalIsOpen,
      guestInfoRef
    ]
  )
  const classes = useStyles()
  const params = useParams<{ channelId: string; code: string; name: string }>()
  const isPersian = persianRegex.test(params.name)
  const nowDate = new Date()

  const [autoCompleteLabelForCurrency, setautoCompleteLabelForCurrency] =
    useState<any>({
      value: searchAvailabilityInput.currency,
      label:
        lang === 'fa'
          ? getTranslate(searchAvailabilityInput.currency || '')
          : searchAvailabilityInput.currency
    })
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  const range =
    dateObject && dateObject.gregorianStartDate && dateObject.gregorianEndDate
      ? calculateRangeOfDays(
          dateObject && dateObject.gregorianStartDate
            ? dateObject.gregorianStartDate
            : `${nowDate.getFullYear()}-${nowDate.getMonth()}-${nowDate.getDate()}`,

          dateObject && dateObject.gregorianEndDate
            ? dateObject.gregorianEndDate
            : `${tomorrow.getFullYear()}-${tomorrow.getMonth()}-${tomorrow.getDate()}`
        )
      : 1

  const selectedDestination = options.find((item) => {
    if (searchAvailabilityInput && searchAvailabilityInput.cityID) {
      return item.cityID === searchAvailabilityInput.cityID
    } else if (
      searchAvailabilityInput &&
      searchAvailabilityInput.propertyCode
    ) {
      return item.destinationCode === searchAvailabilityInput.propertyCode
    }
  })
  if (readMode) {
    return (
      <div className={classes.readMode}>
        <div
          className={classes.searchContainer}
          onClick={() => setreadMode(false)}>
          <SearchIcon className={classes.icon} />
        </div>
        <div className={classes.details}>
          <Typography variant="h6" className={classes.title2}>
            {selectedDestination?.destinationName}
          </Typography>
          <div className={classes.row}>
            <Typography variant="h6" className={classes.title}>
              {`${
                searchAvailabilityInput.arrival &&
                formatShortDateWithWeekDay(
                  searchAvailabilityInput.arrival,
                  lang
                )
              } - ${
                searchAvailabilityInput.departure &&
                formatShortDateWithWeekDay(
                  searchAvailabilityInput.departure,
                  lang
                )
              } ${getTranslate(',')} ${
                searchAvailabilityInput.guestsAges.length
              } ${getTranslate('Travelers')}${getTranslate(
                ','
              )} 1 ${getTranslate('Room')} ${getTranslate(
                'and'
              )} ${range} ${getTranslate('Nights')}`}
            </Typography>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={[
        classes.searchMode,
        isInResultPage ? classes.searchMode2 : ''
      ].join(' ')}>
      <div className={classes.channelName}>
        <Typography style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
          {params.name}
        </Typography>
      </div>
      <Divider className={classes.divider} />
      <div>
        <SearchWidgetSearchInput
          options={options}
          loadingForAccommodation={loadingForAccommodation}
          searchAvailabilityInput={searchAvailabilityInput}
          setSearchAvailabilityInput={setSearchAvailabilityInput}
        />
      </div>
      <Divider className={classes.divider} />
      <div className={classes.dateModalContainer}>
        <div
          role="presentation"
          onClick={() => setSelectRangeModalIsOpen(!selectRangeModalIsOpen)}>
          <SearchWidgetArrivalDate
            data={convertDate(
              dateObject && dateObject.gregorianStartDate
                ? dateObject.gregorianStartDate
                : `${nowDate.getFullYear()}-${nowDate.getMonth()}-${nowDate.getDate()}`
            )}
          />
        </div>
        <Divider orientation="vertical" className={classes.verticalDivider} />
        <div
          role="presentation"
          onClick={() => setSelectRangeModalIsOpen(!selectRangeModalIsOpen)}>
          <SearchWidgetDepartureDate
            data={convertDate(
              dateObject && dateObject.gregorianEndDate
                ? dateObject.gregorianEndDate
                : `${tomorrow.getFullYear()}-${tomorrow.getMonth()}-${tomorrow.getDate()}`
            )}
          />
        </div>
      </div>
      <Divider className={classes.divider} />
      <div onClick={() => setSelectNumberOfGuestsModalIsOpen(true)}>
        <SearchWidgetGuests guestsNumber={guestsNumber} />
        {selectNumberOfGuestsModalIsOpen && (
          <Fade in={selectNumberOfGuestsModalIsOpen} timeout={500}>
            <div className={classes.guestModal} ref={guestInfoRef}>
              <CounterWithLabel
                label={getTranslate('Adults')}
                value={guestsNumber}
                setValue={setguestsNumber}
                min={1}
              />
            </div>
          </Fade>
        )}
      </div>
      <div className={classes.bottom}>
        <div className={classes.currencyContainer}>
          <AutocompleteWithLabel
            disableClearable
            fullWidth
            noHelperText
            value={autoCompleteLabelForCurrency}
            classes={{
              input: classes.currencyLabelColor,
              inputRoot: classes.autocompleteBorder,
              endAdornment: classes.adorment
            }}
            onChange={(_, v: any) => {
              if (v) {
                setautoCompleteLabelForCurrency({
                  value: v.value,
                  label: v.label
                })
                setSearchAvailabilityInput((prev) => ({
                  ...prev,
                  currency: v.value
                }))
              }
            }}
            inputSize="small"
            options={getCurrenciesAvailable().map((currency) => ({
              label:
                lang === 'fa'
                  ? getTranslate(currency as string)
                  : (currency as string),
              value: currency as string
            }))}
          />
        </div>
        <ButtonBase
          component={LocalizedLink}
          to={`/book/${params.channelId}/${params.code}/${params.name}/${
            searchAvailabilityInput.cityID ? 'city' : 'hotel'
          }/?filter=${encodeURIComponent(
            JSON.stringify(searchAvailabilityInput)
          )}`}
          className={classes.buttonBase}
          disabled={
            !(
              searchAvailabilityInput.propertyCode ||
              !!searchAvailabilityInput.cityID
            )
          }>
          <Button
            variant="contained"
            color="primary"
            disabled={
              !!!searchAvailabilityInput.propertyCode &&
              !!!searchAvailabilityInput.cityID
            }
            fullWidth
            className={classes.searchButton}
            onClick={() => setreadMode(!readMode)}
            endIcon={<SearchIcon className={classes.searchIcon} />}>
            <Typography className={classes.btnText}>
              {getTranslate('Search')}
            </Typography>
          </Button>
        </ButtonBase>
      </div>
      {selectRangeModalIsOpen && (
        <Fade in={selectRangeModalIsOpen} timeout={500}>
          <div className={classes.dateModal} ref={datePickerRef}>
            <div className={classes.nightContainer}>
              <div>
                <Typography variant="h3" color="secondary">
                  {range}
                </Typography>
              </div>
              &nbsp;
              <div>
                <Typography variant="h4" color="secondary">
                  {getTranslate('nights')}
                </Typography>
              </div>
            </div>
            <DateRangePicker
              onChange={(date) => {
                setdateObject(date)
              }}
              dateObject={dateObject}
              type={type}
              onDoneClicked={(event) => {
                event.stopPropagation()
                setSelectRangeModalIsOpen(false)
              }}
              endDateCanBeSelectAsStartDate={false}
            />
          </div>
        </Fade>
      )}
    </div>
  )
}
export default SearchWidgetMobileInterface
